import angular from 'angular';
import ngMessages from 'angular-messages';
import {FiltersModule} from "../../filters/app.filters.module";
import {IndexComponent} from "./index.component"
import './index.less';
import {CommonModule} from "../../common/app.common.module";
import {LoginModule} from "../login/login.module";

export const IndexModule = angular
    .module('mmsApp.pages.index', [
        ngMessages,
        FiltersModule,
        CommonModule,
        LoginModule
    ])
    .config(($stateProvider, $urlRouterProvider) => {
        'ngInject';
        $stateProvider
            .state('pages.index', {
                data: {
                    isAuthRequired: false
                },
                url: '/',
                component: IndexComponent.name,
            })
    })
    .component(IndexComponent.name, IndexComponent.component)
    .name
;


// WEBPACK FOOTER //
// ./src/app/pages/index/index.module.js